import * as React from 'react';
import { InputGroup as BootstrapInputGroup } from 'react-bootstrap';
import classNames from 'classnames';

import { Button, ButtonProps } from '../Button';

import classes from './text-input.module.scss';

type InputGroupProps = React.ComponentPropsWithoutRef<
  typeof BootstrapInputGroup
>;

export const InputGroup: React.FC<InputGroupProps> = ({
  className,
  ...props
}) => (
  <BootstrapInputGroup
    className={classNames(classes.inputGroup, className)}
    {...props}
  />
);

type InputGroupAppendProps = React.ComponentPropsWithoutRef<
  typeof BootstrapInputGroup.Append
>;

export const InputGroupAppend: React.FC<InputGroupAppendProps> = ({
  className,
  ...props
}) => (
  <BootstrapInputGroup.Append
    className={classNames(classes.inputGroupAppend, className)}
    {...props}
  />
);

export const InputGroupButton: React.FC<ButtonProps> = ({
  className,
  variant = 'secondary',
  ...props
}) => (
  <Button
    className={classNames(classes.inputGroupButton, className)}
    variant={variant}
    {...props}
  />
);
